<!-- Collapsed on open: the accent unread count in the header is the signal, and
     the resident taps the caret to read. -->
<dropdown-panel title="Messages" [titleNote]="unreadNote" [initiallyExpanded]="false">
  <div class="unread-list">
    <!-- One container around the cards so their space can be given up gradually
         when the last one is ticked. Without it the cards just vanish and the
         panel snaps to the height of the sign-off row. This is a block DIV inside
         the panel, so animating its height is safe - unlike the widget host,
         which is inline and shared with home's card spacing. -->
    <div class="cards" *ngIf="unreadCount" [@cardsCollapse]>
      <div *ngFor="let alert of visibleCards; trackBy: trackAlert" class="alert_cards" [@cardSwap]>
        <alert-card [alert]="alert" (onCheckboxToggled)="updateNotification(alert)"></alert-card>
      </div>
    </div>

    <!-- Once the last unread clears, the panel lingers for its exit animation.
         Offering "See all messages" during that beat is wrong - the resident has
         just finished - so the row becomes a centred sign-off instead. -->
    <div class="actions" *ngIf="unreadCount; else caughtUp">
      <button type="button" class="btn btn_grey" *ngIf="showMarkAll" (click)="markAllRead()">
        Mark all as read
      </button>
      <!-- The home-stack copy of the route, so the push animates. Linking to the
           settings copy from here would cross tab stacks and cut instantly. -->
      <a class="btn btn_accent"
         routerLink="/dashboard/home/message-history"
         routerDirection="forward">
        See all messages
      </a>
    </div>

    <ng-template #caughtUp>
      <div class="actions actions_done">All Caught Up</div>
    </ng-template>
  </div>
</dropdown-panel>
